import React from 'react';
import { Card, Flex, Heading, Text } from 'rebass';
import { withWizard } from 'react-albus';
import PromptIntake from './components/complete/promptIntake';
import Confirmation from './components/complete/confirmation';
import { Query } from 'react-apollo';
import { APPOINTMENTS } from '../../graphql';
import SpinLoader from '../../components/SpinLoader';
import moment from 'moment';
import withSession from '../../lib/withSession';
import withAnalytics, { _getConsentState } from '../../lib/withAnalytics';
import { useEffect } from 'react';
import { uuidv4 } from '../../utils/uuid';

const InsuranceDisclaimer = (props) => {
  return (
    <Card p={4} mb={5} style={{ borderRadius: '20px', background: '#496387', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Flex justifyContent="center" maxWidth={'80%'} flexDirection={'column'} alignItems={'center'}>
        <Heading color={'white'} mb={2} textAlign="center">
          We are reviewing your insurance details
        </Heading>
        <Text textAlign={'center'} mt="12px" color={'white'}>
          Please note that if you are eligible for the insurance membership, you will have to use your insurance for these visits.
        </Text>
      </Flex>
    </Card>
  );
};
const WrapFb = () => {
  useEffect(() => {
    // console.log('WFB')
    const consents = _getConsentState();
    if (!consents || !consents.marketing) {
    // console.log('WFBN')
    return;
  }
    // console.log('WFBY')
    const iframe = document.createElement('iframe');
    iframe.src = '/meta-purchase-frame.html';
    iframe.style.display = 'none';
    iframe.onload = () => {
    // console.log('WFBL')
      iframe.contentWindow.postMessage(
        {
          type: 'META_PURCHASE',
          eventId: uuidv4(),
          value: 240,
          currency: 'USD',
        },
        window.location.origin,
      );
    };

    document.body.appendChild(iframe);

    return () => {
      try {
        iframe.remove();
      } catch (error) {}
    };
  }, []);
  return <div />;
};
export class Complete extends React.Component {
  constructor(props) {
    super(props);

    const { prompt, session, subscribed } = this.props;
    this.state = {
      promptIntake: prompt,
    };
    if (subscribed) {
      this.props.analytics.page();
    }
  }

  render() {
    const { reinitFlow, slot, wizard, currentIntakeStatus, showInsuranceDisclaimer, isMeno, isWeightloss, addPixel } = this.props;
    const { promptIntake } = this.state;
    
    if (wizard && (!slot || !slot.startTime)) {
      reinitFlow(wizard);
      return <div />;
    }

    if (!currentIntakeStatus || currentIntakeStatus !== 'completed') {
      return (
        <>
          {!!addPixel && <WrapFb />}
          {showInsuranceDisclaimer && <InsuranceDisclaimer />}
          <PromptIntake {...this.props} />;
        </>
      );
    } else if (promptIntake) {
      return (
        <Query query={APPOINTMENTS}>
          {({ loading, data, error }) => {
            if (loading) {
              return (
                <Flex flex={1} justifyContent="center" alignItems="center">
                  <SpinLoader />
                </Flex>
              );
            }

            if (error) {
              return (
                <>
                  {!!addPixel && <WrapFb />}
                  {showInsuranceDisclaimer && <InsuranceDisclaimer />}
                  <Confirmation {...this.props} />
                </>
              );
            }
            const { appointments } = data;

            let mustCompleteIntake;
            if (this.props.intakeStatus !== 'completed') {
              mustCompleteIntake = true;
            } else {
              if (!this.props.intakeDate) {
                mustCompleteIntake = true;
              } else {
                if (appointments) {
                  const past = appointments.filter((x) => x.status === '3' || x.status === '4');
                  if (past && past.length > 0) {
                    const pastSorted = past.sort((a, b) => {
                      const aa = moment(a.date, 'MM/DD/YYYY');
                      const bb = moment(b.date, 'MM/DD/YYYY');

                      if (aa.isBefore(bb)) return 1;
                      if (aa.isAfter(bb)) return -1;

                      return 0;
                    });
                    mustCompleteIntake = moment(this.props.intakeDate, 'MM-DD-YYYY').isSameOrBefore(moment(pastSorted[0].date, 'MM/DD/YYYY'), 'day');
                  } else {
                    mustCompleteIntake = false;
                  }
                }
              }
            }

            if (mustCompleteIntake) {
              return (
                <>
                  {!!addPixel && <WrapFb />}
                  {showInsuranceDisclaimer && <InsuranceDisclaimer />}
                  <PromptIntake {...this.props} />;
                </>
              );
            } else {
              return (
                <>
                  {!!addPixel && <WrapFb />}
                  {showInsuranceDisclaimer && <InsuranceDisclaimer />}
                  <Confirmation {...this.props} />;
                </>
              );
            }
          }}
        </Query>
      );
    } else {
      return (
        <>
          {!!addPixel && <WrapFb />}
          {showInsuranceDisclaimer && <InsuranceDisclaimer />}
          <Confirmation {...this.props} />
        </>
      );
    }
  }
}

export default withWizard(withSession(withAnalytics(Complete)));
